import { useState } from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { ButtonUI, CheckboxUI, DialogUI } from '../../Interface';

const ConfidentialityAgreementDialog = ({ dialogData, handleClose, handleAccept }) => {
  const { open, text } = dialogData;
  const [accepted, setAccepted] = useState(false);

  const handleDialogClose = () => {
    setAccepted(false);
    handleClose();
  };

  const handleSave = () => {
    handleAccept();
    setAccepted(false);
  };

  return (
    <DialogUI
      open={open}
      onClose={handleDialogClose}
      headerContent="Titoktartási nyilatkozat"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '900px',
            mx: 1,
          },
        },
      }}
    >
      <Box mt={2}>
        <Typography
          sx={{
            whiteSpace: 'pre-wrap',
            color: text ? 'text.primary' : 'error.main',
          }}
        >
          {text || 'Nem található a titoktartási nyilatkozat szövege!'}
        </Typography>

        <Divider sx={{ my: 2 }} />

        <CheckboxUI
          label={<Typography fontStyle="italic">Elolvastam és elfogadom a titoktartási nyilatkozatot.</Typography>}
          checked={accepted}
          onChange={(e) => setAccepted(e.target.checked)}
          disabled={!text}
        />
      </Box>

      <Box display="flex" gap={2} justifyContent="center" mt="1rem">
        <ButtonUI
          text="Mentés"
          className="bg-success flex gap-2 items-center"
          type="button"
          onClick={handleSave}
          disabled={!accepted}
        />
        <ButtonUI text="Mégse" className="bg-danger flex items-center gap-2" type="button" onClick={handleDialogClose}>
          Bezárás
        </ButtonUI>
      </Box>
    </DialogUI>
  );
};

export default ConfidentialityAgreementDialog;
